var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"items":_vm.items,"value":_vm.selectedValue,"rules":_vm.computedRules,"disabled":_vm.disabled,"readonly":_vm.readonly},on:{"input":_vm.onInput}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }